import React from 'react';
import PropTypes from 'prop-types';
import MuiAppBar from '@material-ui/core/AppBar';
import cx from 'classnames';
import Toolbar from '@material-ui/core/Toolbar';
import { AppLogo } from 'src/components/AppLogo';
import FlexGrow from 'src/components/FlexGrow/FlexGrow';
import { ItemsMobile } from '../ItemsMobile';
import { useStyles } from './useStyles';

export const MobileNavBar = ({ className }) => {
  const styles = useStyles();

  return (
    <MuiAppBar
      className={cx(styles.muiAppBar, className)}
      elevation={0}
      position="static"
      data-testid="MobileNavBar"
    >
      <Toolbar className={cx(styles.toolbar)} disableGutters>
        <AppLogo />
        <FlexGrow />

        <ItemsMobile />
      </Toolbar>
    </MuiAppBar>
  );
};

MobileNavBar.propTypes = {
  className: PropTypes.string,
};

MobileNavBar.defaultProps = {
  className: '',
};
